export const pinsQueryKeys = {
  GET_PROJECT_PINS: 'getProjectPins',
  GET_PROJECT_PINS_INFINITY: 'getProjectPinsInfinity',
  GET_PLAN_PINS_INFINITY: 'getPlanPinsInfinity',
  GET_PLAN_PINS_COUNT: 'getPlanPinsCount'
}
